import React from 'react';
import Icon from '../../../components/AppIcon';

import Button from '../../../components/ui/Button';

const FeaturedOffers = ({ offers, onOfferClick, userTier }) => {
  const getTierEligibility = (offer) => {
    const tierLevels = { 'Intro': 1, 'All Access': 2, 'Flex': 3, 'Premium': 4 };
    const userLevel = tierLevels?.[userTier] || 0;
    const requiredLevel = tierLevels?.[offer?.requiredTier] || 0;
    return userLevel >= requiredLevel;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-wellness p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Sparkles" size={24} className="text-accent" />
          <h2 className="font-heading font-bold text-xl text-foreground">Featured Offers</h2>
        </div>
        <Button variant="outline" size="sm" iconName="ArrowRight">
          View All
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {offers?.map((offer) => {
          const isEligible = getTierEligibility(offer);
          
          return (
            <div
              key={offer?.id}
              className={`relative bg-gradient-to-br ${offer?.gradient} rounded-lg p-4 text-white overflow-hidden cursor-pointer transition-wellness hover:scale-105 ${
                !isEligible ? 'opacity-60' : ''
              }`}
              onClick={() => isEligible && onOfferClick?.(offer)}
            >
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 right-0 w-32 h-32 rounded-full bg-white transform translate-x-16 -translate-y-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 rounded-full bg-white transform -translate-x-12 translate-y-12"></div>
              </div>
              {/* Content */}
              <div className="relative z-10">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center space-x-2">
                    <Icon name={offer?.icon} size={20} />
                    <span className="text-sm font-medium opacity-90">{offer?.type}</span>
                  </div>
                  {offer?.discount && (
                    <div className="bg-white/20 px-2 py-1 rounded-full">
                      <span className="text-xs font-bold">{offer?.discount}% OFF</span>
                    </div>
                  )}
                </div>

                <h3 className="font-heading font-bold text-lg mb-2 line-clamp-2">
                  {offer?.title}
                </h3>

                <p className="text-sm opacity-90 mb-3 line-clamp-2">
                  {offer?.description}
                </p>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    {offer?.originalPrice && (
                      <span className="text-sm line-through opacity-75">
                        ${offer?.originalPrice}
                      </span>
                    )}
                    <span className="font-bold text-lg">
                      ${offer?.price}
                    </span>
                  </div>
                  
                  <div className="flex items-center space-x-1 text-xs opacity-90">
                    <Icon name="Clock" size={12} />
                    <span>{offer?.validUntil}</span>
                  </div>
                </div>

                {/* Tier Requirement */}
                {offer?.requiredTier && (
                  <div className="flex items-center justify-between mt-3 pt-3 border-t border-white/20">
                    <div className="flex items-center space-x-1">
                      <Icon name="Award" size={14} />
                      <span className="text-xs">{offer?.requiredTier}+ Required</span>
                    </div>
                    {!isEligible && (
                      <span className="text-xs bg-white/20 px-2 py-1 rounded-full">
                        Upgrade to Access
                      </span>
                    )}
                  </div>
                )}

                {/* Center Info */}
                <div className="flex items-center space-x-2 mt-2">
                  <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                    <Icon name="MapPin" size={12} />
                  </div>
                  <span className="text-xs opacity-90">{offer?.centerName}</span>
                </div>
              </div>
              {/* Lock Overlay for Ineligible Offers */}
              {!isEligible && (
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center z-20">
                  <div className="bg-white/90 rounded-full p-3">
                    <Icon name="Lock" size={24} className="text-muted-foreground" />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* Promotional Banner */}
      <div className="mt-6 bg-gradient-to-r from-primary to-secondary rounded-lg p-4 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <Icon name="Gift" size={24} />
            </div>
            <div>
              <h3 className="font-heading font-bold">New Member Special</h3>
              <p className="text-sm opacity-90">Get 25% off your first purchase + free consultation</p>
            </div>
          </div>
          <Button variant="secondary" size="sm">
            Claim Offer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FeaturedOffers;